export class DisableBranchMiniEntity {
    id?: number;
    title?: string | null;
}